import { VIEW_MANAGEMENT } from 'store/types';

function showNotificationsDialog() {
  return {
    type: VIEW_MANAGEMENT.SHOW_NOTIFICATION_DIALOG,
  };
}

export default showNotificationsDialog;
